<script setup lang="ts">
import { computed } from 'vue'
import type { ToastInternal } from '@client-streamer/types/toast.type'
import StatusGlyph, { type StatusGlyphKind } from '@client-streamer/components/streamer/StatusGlyph.vue'

const props = defineProps<{ toast: ToastInternal }>()

// A toast is a calm panel; only its glyph says how it went.
const glyph = computed<StatusGlyphKind>(() => {
  switch (props.toast.type) {
    case 'success':
      return 'ready'
    case 'error':
    case 'warning':
      return 'needs'
    case 'info':
      return 'holding'
    default:
      return 'off'
  }
})
</script>

<template>
  <div class="studio-toast" :data-type="toast.type" @click="toast.onClick && toast.onClick()">
    <StatusGlyph :kind="glyph" />
    <span>{{ toast.message }}</span>
  </div>
</template>

<style scoped>
.studio-toast {
  display: flex;
  align-items: center;
  gap: 10px;
  max-width: min(420px, calc(100vw - 32px));
  padding: 10px 14px;
  border: 1px solid var(--studio-border-strong);
  border-radius: var(--studio-radius-lg);
  background: var(--studio-popover);
  box-shadow: 0 16px 40px rgb(0 0 0 / 0.45);
  color: var(--studio-text);
  font-size: 13px;
  cursor: pointer;
  transition:
    opacity 0.2s,
    transform 0.2s;
}
.studio-toast[data-type='info'] :deep(.status-glyph path) {
  animation: none;
}
</style>
